<script lang="ts">
    import Header from "./Components/Header.svelte";
    import Router from "./Router.svelte";
</script>

<div class="container is-liquid">
    <Header />
    <Router>
        <slot />
    </Router>
</div>

<style>
</style>
